export const systemsKeys = {
    all: ["systems"] as const,
    byId: (id: string) => [...systemsKeys.all, id] as const
};
